// -----------------------------------------------------------
// Author  : Mathieu Bucher
// Resume  : Hook to send a predefined message as a chat query
// Date    : 2026-03-06
// Ref.    : feat/document-reference-links
// -----------------------------------------------------------
import { useAuth } from "@clerk/react-router";
import { useSendPredefinedMessage as useSendPredefinedMessageBase } from "@noa/ui";
import { useNavigate } from "react-router";

export const useSendPredefinedMessage = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  // The prompt goes into the active session; route to its conversation (or Home if none yet) —
  // the same seamless redirect as a typed first message.
  return useSendPredefinedMessageBase(Boolean(isSignedIn), (sessionId) => {
    navigate(sessionId ? `/conversation/${sessionId}` : "/");
  });
};
